import Collections from "../../components/Collections";
function CollectionsPage() {
  return (
    <div>
      <Collections />
    </div>
  );
}

export default CollectionsPage;
